"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mockNewLessonsResponse = exports.mockLessons = exports.mockLessonsResponse = void 0;
exports.mockLessonsResponse = {
    lessons: [
        {
            uuid: '636b793e8408832e2f04b2dcX',
            category: 'Authentication',
            challengeQuery: 'tags=Forceful-Browsing',
            description: 'Forceful (or forced) browsing is a common attack technique used to gain access to web server resources that are restricted, or resources that are accessed outside of the intended (correct) sequence. An attacker carries out the attack by guessing, knowing or inferring the correct URL directly. If the restricted URLs, scripts, or files that reside in the web server directory are not enforced with appropriate authorization or sequencing logic, they can be vulnerable to forceful browsing attacks.',
            duration: '5-8',
            externalUrl: '/courses/android/index.html',
            format: 'cms',
            iconUrl: 'https://codebashing-prod-eu-content.s3.eu-west-1.amazonaws.com/courses/android/icons/forceful_browsing.png',
            metadata: {
                active_on_free: true,
                content_id: 855,
                content_name: 'forceful_browsing_android',
                course_name: 'android',
                lesson_name: 'forceful_browsing',
                new_lesson_free: false,
            },
            name: 'Lesson 1',
            status: 'active',
        },
        {
            uuid: '636b793e8408832e2f04b2dcX',
            category: 'Authentication',
            challengeQuery: 'tags=Forceful-Browsing',
            description: 'Forceful (or forced) browsing is a common attack technique used to gain access to web server resources that are restricted, or resources that are accessed outside of the intended (correct) sequence. An attacker carries out the attack by guessing, knowing or inferring the correct URL directly. If the restricted URLs, scripts, or files that reside in the web server directory are not enforced with appropriate authorization or sequencing logic, they can be vulnerable to forceful browsing attacks.',
            duration: '5-8',
            externalUrl: '/courses/android/index.html',
            format: 'cms',
            iconUrl: 'https://codebashing-prod-eu-content.s3.eu-west-1.amazonaws.com/courses/android/icons/forceful_browsing.png',
            metadata: {
                active_on_free: true,
                content_id: 855,
                content_name: 'forceful_browsing_android',
                course_name: 'android',
                lesson_name: 'forceful_browsing',
                new_lesson_free: false,
            },
            name: 'Lesson 1',
            status: 'active',
        },
        {
            uuid: '636b793e8408832e2f04b2dcX',
            category: 'Authentication',
            challengeQuery: 'tags=Forceful-Browsing',
            description: 'Forceful (or forced) browsing is a common attack technique used to gain access to web server resources that are restricted, or resources that are accessed outside of the intended (correct) sequence. An attacker carries out the attack by guessing, knowing or inferring the correct URL directly. If the restricted URLs, scripts, or files that reside in the web server directory are not enforced with appropriate authorization or sequencing logic, they can be vulnerable to forceful browsing attacks.',
            duration: '5-8',
            externalUrl: '/courses/android/index.html',
            format: 'cms',
            iconUrl: 'https://codebashing-prod-eu-content.s3.eu-west-1.amazonaws.com/courses/android/icons/forceful_browsing.png',
            metadata: {
                active_on_free: true,
                content_id: 855,
                content_name: 'forceful_browsing_android',
                course_name: 'android',
                lesson_name: 'forceful_browsing',
                new_lesson_free: false,
            },
            name: 'Lesson 1',
            status: 'active',
        },
        {
            uuid: '636b793e8408832e2f04b2dcX',
            category: 'Authentication',
            challengeQuery: 'tags=Forceful-Browsing',
            description: 'Forceful (or forced) browsing is a common attack technique used to gain access to web server resources that are restricted, or resources that are accessed outside of the intended (correct) sequence. An attacker carries out the attack by guessing, knowing or inferring the correct URL directly. If the restricted URLs, scripts, or files that reside in the web server directory are not enforced with appropriate authorization or sequencing logic, they can be vulnerable to forceful browsing attacks.',
            duration: '5-8',
            externalUrl: '/courses/android/index.html',
            format: 'cms',
            iconUrl: 'https://codebashing-prod-eu-content.s3.eu-west-1.amazonaws.com/courses/android/icons/forceful_browsing.png',
            metadata: {
                active_on_free: true,
                content_id: 855,
                content_name: 'forceful_browsing_android',
                course_name: 'android',
                lesson_name: 'forceful_browsing',
                new_lesson_free: false,
            },
            name: 'Lesson 1',
            status: 'active',
        },
        {
            uuid: '636b793e8408832e2f04b2dcX',
            category: 'Authentication',
            challengeQuery: 'tags=Forceful-Browsing',
            description: 'Forceful (or forced) browsing is a common attack technique used to gain access to web server resources that are restricted, or resources that are accessed outside of the intended (correct) sequence. An attacker carries out the attack by guessing, knowing or inferring the correct URL directly. If the restricted URLs, scripts, or files that reside in the web server directory are not enforced with appropriate authorization or sequencing logic, they can be vulnerable to forceful browsing attacks.',
            duration: '5-8',
            externalUrl: '/courses/android/index.html',
            format: 'cms',
            iconUrl: 'https://codebashing-prod-eu-content.s3.eu-west-1.amazonaws.com/courses/android/icons/forceful_browsing.png',
            metadata: {
                active_on_free: true,
                content_id: 855,
                content_name: 'forceful_browsing_android',
                course_name: 'android',
                lesson_name: 'forceful_browsing',
                new_lesson_free: false,
            },
            name: 'Lesson 1',
            status: 'active',
        },
        {
            uuid: '636b793e8408832e2f04b2dcX',
            category: 'Authentication',
            challengeQuery: 'tags=Forceful-Browsing',
            description: 'Forceful (or forced) browsing is a common attack technique used to gain access to web server resources that are restricted, or resources that are accessed outside of the intended (correct) sequence. An attacker carries out the attack by guessing, knowing or inferring the correct URL directly. If the restricted URLs, scripts, or files that reside in the web server directory are not enforced with appropriate authorization or sequencing logic, they can be vulnerable to forceful browsing attacks.',
            duration: '5-8',
            externalUrl: '/courses/android/index.html',
            format: 'cms',
            iconUrl: 'https://codebashing-prod-eu-content.s3.eu-west-1.amazonaws.com/courses/android/icons/forceful_browsing.png',
            metadata: {
                active_on_free: true,
                content_id: 855,
                content_name: 'forceful_browsing_android',
                course_name: 'android',
                lesson_name: 'forceful_browsing',
                new_lesson_free: false,
            },
            name: 'Lesson 1',
            status: 'active',
        },
        {
            uuid: '636b793e8408832e2f04b2dcX',
            category: 'Authentication',
            challengeQuery: 'tags=Forceful-Browsing',
            description: 'Forceful (or forced) browsing is a common attack technique used to gain access to web server resources that are restricted, or resources that are accessed outside of the intended (correct) sequence. An attacker carries out the attack by guessing, knowing or inferring the correct URL directly. If the restricted URLs, scripts, or files that reside in the web server directory are not enforced with appropriate authorization or sequencing logic, they can be vulnerable to forceful browsing attacks.',
            duration: '5-8',
            externalUrl: '/courses/android/index.html',
            format: 'cms',
            iconUrl: 'https://codebashing-prod-eu-content.s3.eu-west-1.amazonaws.com/courses/android/icons/forceful_browsing.png',
            metadata: {
                active_on_free: true,
                content_id: 855,
                content_name: 'forceful_browsing_android',
                course_name: 'android',
                lesson_name: 'forceful_browsing',
                new_lesson_free: false,
            },
            name: 'Lesson 1',
            status: 'active',
        },
        {
            uuid: '636b793e8408832e2f04b2dcX',
            category: 'Authentication',
            challengeQuery: 'tags=Forceful-Browsing',
            description: 'Forceful (or forced) browsing is a common attack technique used to gain access to web server resources that are restricted, or resources that are accessed outside of the intended (correct) sequence. An attacker carries out the attack by guessing, knowing or inferring the correct URL directly. If the restricted URLs, scripts, or files that reside in the web server directory are not enforced with appropriate authorization or sequencing logic, they can be vulnerable to forceful browsing attacks.',
            duration: '5-8',
            externalUrl: '/courses/android/index.html',
            format: 'cms',
            iconUrl: 'https://codebashing-prod-eu-content.s3.eu-west-1.amazonaws.com/courses/android/icons/forceful_browsing.png',
            metadata: {
                active_on_free: true,
                content_id: 855,
                content_name: 'forceful_browsing_android',
                course_name: 'android',
                lesson_name: 'forceful_browsing',
                new_lesson_free: false,
            },
            name: 'Lesson 1',
            status: 'active',
        },
        {
            uuid: '636b793e8408832e2f04b2dcX',
            category: 'Authentication',
            challengeQuery: 'tags=Forceful-Browsing',
            description: 'Forceful (or forced) browsing is a common attack technique used to gain access to web server resources that are restricted, or resources that are accessed outside of the intended (correct) sequence. An attacker carries out the attack by guessing, knowing or inferring the correct URL directly. If the restricted URLs, scripts, or files that reside in the web server directory are not enforced with appropriate authorization or sequencing logic, they can be vulnerable to forceful browsing attacks.',
            duration: '5-8',
            externalUrl: '/courses/android/index.html',
            format: 'cms',
            iconUrl: 'https://codebashing-prod-eu-content.s3.eu-west-1.amazonaws.com/courses/android/icons/forceful_browsing.png',
            metadata: {
                active_on_free: true,
                content_id: 855,
                content_name: 'forceful_browsing_android',
                course_name: 'android',
                lesson_name: 'forceful_browsing',
                new_lesson_free: false,
            },
            name: 'Lesson 1',
            status: 'active',
        },
        {
            uuid: '636b793e8408832e2f04b2dcX',
            category: 'Authentication',
            challengeQuery: 'tags=Forceful-Browsing',
            description: 'Forceful (or forced) browsing is a common attack technique used to gain access to web server resources that are restricted, or resources that are accessed outside of the intended (correct) sequence. An attacker carries out the attack by guessing, knowing or inferring the correct URL directly. If the restricted URLs, scripts, or files that reside in the web server directory are not enforced with appropriate authorization or sequencing logic, they can be vulnerable to forceful browsing attacks.',
            duration: '5-8',
            externalUrl: '/courses/android/index.html',
            format: 'cms',
            iconUrl: 'https://codebashing-prod-eu-content.s3.eu-west-1.amazonaws.com/courses/android/icons/forceful_browsing.png',
            metadata: {
                active_on_free: true,
                content_id: 855,
                content_name: 'forceful_browsing_android',
                course_name: 'android',
                lesson_name: 'forceful_browsing',
                new_lesson_free: false,
            },
            name: 'Lesson 1',
            status: 'active',
        },
        {
            uuid: '636b793e8408832e2f04b2dcX',
            category: 'Authentication',
            challengeQuery: 'tags=Forceful-Browsing',
            description: 'Forceful (or forced) browsing is a common attack technique used to gain access to web server resources that are restricted, or resources that are accessed outside of the intended (correct) sequence. An attacker carries out the attack by guessing, knowing or inferring the correct URL directly. If the restricted URLs, scripts, or files that reside in the web server directory are not enforced with appropriate authorization or sequencing logic, they can be vulnerable to forceful browsing attacks.',
            duration: '5-8',
            externalUrl: '/courses/android/index.html',
            format: 'cms',
            iconUrl: 'https://codebashing-prod-eu-content.s3.eu-west-1.amazonaws.com/courses/android/icons/forceful_browsing.png',
            metadata: {
                active_on_free: true,
                content_id: 855,
                content_name: 'forceful_browsing_android',
                course_name: 'android',
                lesson_name: 'forceful_browsing',
                new_lesson_free: false,
            },
            name: 'Lesson 1',
            status: 'active',
        },
        {
            uuid: '636b793e8408832e2f04b2dcX',
            category: 'Authentication',
            challengeQuery: 'tags=Forceful-Browsing',
            description: 'Forceful (or forced) browsing is a common attack technique used to gain access to web server resources that are restricted, or resources that are accessed outside of the intended (correct) sequence. An attacker carries out the attack by guessing, knowing or inferring the correct URL directly. If the restricted URLs, scripts, or files that reside in the web server directory are not enforced with appropriate authorization or sequencing logic, they can be vulnerable to forceful browsing attacks.',
            duration: '5-8',
            externalUrl: '/courses/android/index.html',
            format: 'cms',
            iconUrl: 'https://codebashing-prod-eu-content.s3.eu-west-1.amazonaws.com/courses/android/icons/forceful_browsing.png',
            metadata: {
                active_on_free: true,
                content_id: 855,
                content_name: 'forceful_browsing_android',
                course_name: 'android',
                lesson_name: 'forceful_browsing',
                new_lesson_free: false,
            },
            name: 'Lesson 1',
            status: 'active',
        },
        {
            uuid: '2',
            category: 'Authentication',
            challengeQuery: 'tags=Forceful-Browsing',
            description: 'Forceful (or forced) browsing is a common attack technique used to gain access to web server resources that are restricted, or resources that are accessed outside of the intended (correct) sequence. An attacker carries out the attack by guessing, knowing or inferring the correct URL directly. If the restricted URLs, scripts, or files that reside in the web server directory are not enforced with appropriate authorization or sequencing logic, they can be vulnerable to forceful browsing attacks.',
            duration: '5-8',
            externalUrl: '/courses/android/index.html',
            format: 'cms',
            iconUrl: 'https://codebashing-prod-eu-content.s3.eu-west-1.amazonaws.com/courses/android/icons/forceful_browsing.png',
            metadata: {
                active_on_free: true,
                content_id: 855,
                content_name: 'forceful_browsing_android',
                course_name: 'android',
                lesson_name: 'forceful_browsing',
                new_lesson_free: false,
            },
            name: 'Lesson 2',
            status: 'active',
        },
    ],
};
exports.mockLessons = {
    lessons: [
        {
            uuid: '633eb5a2987aa842d93130f5',
            description: 'Cryptographic failures are a vulnerability category focusing on a lack of or inappropriate protection, which often leads to the exposure of sensitive data. Play and learn...',
            format: 'sl',
            name: 'Cryptographic Failures',
            iconUrl: 'https://content.codebashing.com/courses-assets/cryptographic_failures.svg',
            category: null,
            externalUrl: '/courses/scorm-lessons/index.html',
            challengeQuery: null,
            duration: '5-8',
            status: 'active',
            tags: [],
            metadata: {
                course_name: 'appsec_for_decision_makers',
                lesson_name: 'cryptographic_failures',
                active_on_lean: true,
            },
            publishInfo: ['~kMC*2)yN%5a}vJ9v8s726t7O#r[aA', 'OX)jOt$nPFn`b2Jy-Pa!N[DcD3@}z3'],
        },
        {
            uuid: '6167f2038df8878a7376a554',
            description: 'Components with known vulnerabilities can pose a serious threat to application security. Since the knowledge about these vulnerabilities is discoverable on open sources, attackers can easily exploit them to their advantage. Play and learn... ',
            format: 'cms',
            name: 'Vulnerable and Outdated Components',
            iconUrl: 'https://codebashing-prod-eu-content.s3-eu-west-1.amazonaws.com/courses-assets/using_components_with_known_vulnerabilities.svg',
            category: null,
            externalUrl: '/courses/frontend/index.html',
            challengeQuery: 'tags=lesson_application_security_for_decision_makers_using_components_with_known_vulnerabilties',
            duration: '5-8',
            status: 'active',
            tags: [
                {
                    uuid: '63a991ccec399663ece8c3c3',
                    name: 'using_components_with_known_vulnerabilities',
                    displayName: 'Short tag',
                    category: 'vulnerability',
                    metadata: {
                        cweId: 'CWE-1035',
                        owaspId: 'A6: Vulnerable and Outdated Components ',
                        sansId: null,
                    },
                    tagCount: 1,
                    relatedTags: [],
                },
                {
                    uuid: '63a991ccec399663ece8c3c3',
                    name: 'using_components_with_known_vulnerabilities',
                    displayName: 'Short tag',
                    category: 'vulnerability',
                    metadata: {
                        cweId: 'CWE-1035',
                        owaspId: 'A6: Vulnerable and Outdated Components ',
                        sansId: null,
                    },
                    tagCount: 1,
                    relatedTags: [],
                },
            ],
            metadata: {
                active_on_free: false,
                course_name: 'appsec_for_decision_makers',
                lesson_name: 'using_components_with_known_vulnerabilities',
                content_name: 'application_security_for_decision_makers_using_components_with_known_vulnerabilities',
                content_id: 1089,
                active_on_lean: true,
            },
            publishInfo: ['~kMC*2)yN%5a}vJ9v8s726t7O#r[aA', 'OX)jOt$nPFn`b2Jy-Pa!N[DcD3@}z3'],
        },
        {
            uuid: '629dd83f1545d7f982d16e70',
            description: 'sadasdssa',
            format: 'cms',
            name: 'Server-Side Request Forgery (SSRF)',
            iconUrl: 'https://codebashing-prod-eu-content.s3-eu-west-1.amazonaws.com/courses-assets/ssrf_logo.svg',
            category: null,
            externalUrl: '/courses/frontend/index.html',
            challengeQuery: 'tags=lesson_application_security_for_decision_makers_ssrf',
            duration: '5-8',
            status: 'active',
            tags: [
                {
                    uuid: '63a991d08e0fc84823c362e8',
                    name: 'server_side_request_forgery_ssrf',
                    displayName: 'Server Side Request Forgery Ssrf',
                    category: 'vulnerability',
                    metadata: {
                        cweId: '',
                        owaspId: 'A10:2021',
                        sansId: '',
                    },
                    tagCount: 1,
                    relatedTags: [],
                },
            ],
            metadata: {
                course_name: 'appsec_for_decision_makers',
                lesson_name: 'server_side_request_forgery_ssrf',
                active_on_lean: true,
            },
            publishInfo: ['~kMC*2)yN%5a}vJ9v8s726t7O#r[aA', 'OX)jOt$nPFn`b2Jy-Pa!N[DcD3@}z3'],
        },
        {
            uuid: '632acd1c78a017ba67871b8f',
            description: 'Insecure design is a category of vulnerabilities caused by not anticipating and evaluating threats.\nDesign flaws tend to be overlooked and not easily fixed.\nAdding security measures or changing the architecture of a running app is time-consuming and costly. Play and learn…',
            format: 'sl',
            name: 'Insecure Design',
            iconUrl: 'https://content.codebashing.com/courses-assets/insecure_design.svg',
            category: null,
            externalUrl: '/courses/scorm-lessons/index.html',
            challengeQuery: null,
            duration: '5-8',
            status: 'active',
            tags: [],
            metadata: {
                course_name: 'appsec_for_decision_makers',
                lesson_name: 'insecure_design',
                active_on_lean: true,
            },
            publishInfo: ['~kMC*2)yN%5a}vJ9v8s726t7O#r[aA', 'OX)jOt$nPFn`b2Jy-Pa!N[DcD3@}z3'],
        },
        {
            uuid: '6167f1ffc27d3df88a952935',
            description: ' a common attack technique used to gain access to web server resources that are restricted, or resources that are accessed outside of the intended (correct) sequence. An attacker carries out the attack by guessing, knowing or inferring the correct URL directly. If the restricted URLs, scripts, or files that reside in the web server directory are not enforced with appropriate authorization or sequencing logic, they can be vulnerable to forceful browsing attacks.',
            format: 'cms',
            name: ' Identification and Authentication Failures',
            iconUrl: 'https://codebashing-prod-eu-content.s3-eu-west-1.amazonaws.com/courses-assets/broken_authentication.svg',
            category: null,
            externalUrl: '/courses/frontend/index.html',
            challengeQuery: 'tags=lesson_application_security_for_decision_makers_broken_authentication​',
            duration: '5-8',
            status: 'active',
            tags: [
                {
                    uuid: '63a991cc8e0fc85ff9c362de',
                    name: 'broken_authentication',
                    displayName: 'Broken Authentication',
                    category: 'vulnerability',
                    metadata: {
                        cweId: 'CWE-1028',
                        owaspId: 'A7: Identification and Authentication Failures ',
                        sansId: null,
                    },
                    tagCount: 1,
                    relatedTags: [],
                },
            ],
            metadata: {
                active_on_free: false,
                course_name: 'appsec_for_decision_makers',
                lesson_name: 'broken_authentication',
                content_name: 'application_security_for_decision_makers_broken_authentication',
                content_id: 1086,
                active_on_lean: true,
            },
            publishInfo: ['~kMC*2)yN%5a}vJ9v8s726t7O#r[aA', 'OX)jOt$nPFn`b2Jy-Pa!N[DcD3@}z3'],
        },
        {
            uuid: '6167f202c27d3d009b95293b',
            description: 'Security misconfigurations in applications may often go unnoticed by developers, however this type of weakness is frequently exploited to carry out various types of attacks. Play and learn…',
            format: 'cms',
            name: 'Security Misconfigurations',
            iconUrl: 'https://codebashing-prod-eu-content.s3-eu-west-1.amazonaws.com/courses-assets/security_misconfigurations.svg',
            category: null,
            externalUrl: '/courses/frontend/index.html',
            challengeQuery: 'tags=lesson_application_security_for_decision_makers_security_misconfigurations',
            duration: '5-8',
            status: 'active',
            tags: [
                {
                    uuid: '63a991cc1d8f6f326312ae2d',
                    name: 'security_misconfigurations',
                    displayName: 'Security Misconfigurations',
                    category: 'vulnerability',
                    metadata: {
                        cweId: 'CWE-1032',
                        owaspId: 'A5: Security Misconfiguration ',
                        sansId: null,
                    },
                    tagCount: 1,
                    relatedTags: [],
                },
            ],
            metadata: {
                active_on_free: false,
                course_name: 'appsec_for_decision_makers',
                lesson_name: 'security_misconfigurations',
                content_name: 'application_security_for_decision_makers_security_misconfigurations',
                content_id: 1085,
                active_on_lean: true,
            },
            publishInfo: ['OX)jOt$nPFn`b2Jy-Pa!N[DcD3@}z3'],
        },
        {
            uuid: '6167f2012479f17031d5571a',
            description: 'Insufficient logging and monitoring are one reason security incidents are sometimes not detected or detected much too late. Attackers rely on inadequate logging and monitoring to advance their attacks without being caught. Play and learn…',
            format: 'cms',
            name: 'Security Logging and Monitoring Failures',
            iconUrl: 'https://codebashing-prod-eu-content.s3-eu-west-1.amazonaws.com/courses-assets/insufficient_logging_and_monitoring_lesson_logo.svg',
            category: null,
            externalUrl: '/courses/frontend/index.html',
            challengeQuery: 'tags=lesson_application_security_for_decision_makers_insufficient_logging_and_monitoring',
            duration: '5-8',
            status: 'active',
            tags: [
                {
                    uuid: '63a991cd1d8f6f9b5812ae2f',
                    name: 'insufficient_logging_and_monitoring',
                    displayName: 'Insufficient Logging And Monitoring',
                    category: 'vulnerability',
                    metadata: {
                        cweId: 'CWE-778',
                        owaspId: 'A9: Security Logging and Monitoring Failures ',
                        sansId: null,
                    },
                    tagCount: 1,
                    relatedTags: [],
                },
            ],
            metadata: {
                active_on_free: false,
                course_name: 'appsec_for_decision_makers',
                lesson_name: 'insufficient_logging_and_monitoring',
                content_name: 'application_security_for_decision_makers_insufficient_logging_and_monitoring',
                content_id: 1101,
                active_on_lean: true,
            },
            publishInfo: ['~kMC*2)yN%5a}vJ9v8s726t7O#r[aA', 'OX)jOt$nPFn`b2Jy-Pa!N[DcD3@}z3'],
        },
        {
            uuid: '6167f200c27d3dcf8b952938',
            description: 'Insecure Object Deserialization is a security vulnerability that permits an attacker to abuse application logic, deny service, or execute arbitrary code, when an object is being deserialized. Play and Learn...',
            format: 'cms',
            name: 'Insecure Object Deserialization',
            iconUrl: 'https://codebashing-prod-eu-content.s3-eu-west-1.amazonaws.com/courses-assets/insecure_deserialization_lesson_logo.svg',
            category: null,
            externalUrl: '/courses/frontend/index.html',
            challengeQuery: 'tags=lesson_application_security_for_decision_makers_insecure_object_deserialization',
            duration: '5-8',
            status: 'active',
            tags: [
                {
                    uuid: '61c98bdcdd910c63aa8abf9d',
                    name: 'insecure_object_deserialization',
                    displayName: 'Insecure Object Deserialization',
                    category: 'vulnerability',
                    metadata: {
                        cweId: 'CWE-502',
                        owaspId: 'A8: Software and Data Integrity Failures',
                        sansId: null,
                    },
                    tagCount: 1,
                    relatedTags: [],
                },
            ],
            metadata: {
                active_on_free: false,
                course_name: 'appsec_for_decision_makers',
                lesson_name: 'insecure_object_deserialization',
                content_name: 'application_security_for_decision_makers_insecure_object_deserialization',
                content_id: 1100,
                active_on_lean: true,
            },
            publishInfo: ['~kMC*2)yN%5a}vJ9v8s726t7O#r[aA', 'OX)jOt$nPFn`b2Jy-Pa!N[DcD3@}z3'],
        },
        {
            uuid: '6167f2022479f1807bd5571d',
            description: 'Sensitive data, such as personally identifiable information, business secrets, and sensitive system information, must be protected from unauthorized access. Failure to do so can lead to data breaches, data thefts, business disruption, and even legal penalties. It is best to employ appropriate security controls for protecting the data being used by the application. Play and learn...',
            format: 'cms',
            name: ' Sensitive Data Exposure',
            iconUrl: 'https://codebashing-prod-eu-content.s3-eu-west-1.amazonaws.com/courses-assets/sensitive_data_exposure.svg',
            category: null,
            externalUrl: '/courses/frontend/index.html',
            challengeQuery: 'tags=lesson_application_security_for_decision_makers_sensitive_data_exposure',
            duration: '5-8',
            status: 'active',
            tags: [
                {
                    uuid: '63a991c91d8f6f18dd12ae25',
                    name: 'sensitive_data_exposure',
                    displayName: 'Sensitive Data Exposure',
                    category: 'vulnerability',
                    metadata: {
                        cweId: 'CWE-540',
                        owaspId: 'A2: Cryptographic Failures',
                        sansId: null,
                    },
                    tagCount: 1,
                    relatedTags: [],
                },
            ],
            metadata: {
                active_on_free: false,
                course_name: 'appsec_for_decision_makers',
                lesson_name: 'sensitive_data_exposure',
                content_name: 'application_security_for_decision_makers_sensitive_data_exposure',
                content_id: 1088,
                active_on_lean: true,
            },
            publishInfo: ['~kMC*2)yN%5a}vJ9v8s726t7O#r[aA', 'OX)jOt$nPFn`b2Jy-Pa!N[DcD3@}z3'],
        },
        {
            uuid: '6167f1ff8df887341076a54b',
            description: 'Broken Access Control is a vulnerability caused by faulty access protocol in an application that allows a user to access unauthorized features and resources. Attackers scan the web for such applications and can exploit such vulnerability to gain user or admin privileges and break other security controls in the application.​ Play and learn… ',
            format: 'cms',
            name: 'Broken Access Control',
            iconUrl: 'https://codebashing-prod-eu-content.s3-eu-west-1.amazonaws.com/courses-assets/broken_access_control.svg',
            category: null,
            externalUrl: '/courses/frontend/index.html',
            challengeQuery: 'tags=lesson_application_security_for_decision_makers_broken_access_control',
            duration: '5-8',
            status: 'active',
            tags: [
                {
                    uuid: '63a991cb8e0fc8fd1cc362dc',
                    name: 'broken_access_control',
                    displayName: 'Broken Access Control',
                    category: 'vulnerability',
                    metadata: {
                        cweId: 'CWE-248',
                        owaspId: 'A1: Broken Access Control ',
                        sansId: null,
                    },
                    tagCount: 1,
                    relatedTags: [],
                },
            ],
            metadata: {
                active_on_free: false,
                course_name: 'appsec_for_decision_makers',
                lesson_name: 'broken_access_control',
                content_name: 'application_security_for_decision_makers_broken_access_control',
                content_id: 1083,
                active_on_lean: true,
            },
            publishInfo: ['~kMC*2)yN%5a}vJ9v8s726t7O#r[aA', 'OX)jOt$nPFn`b2Jy-Pa!N[DcD3@}z3'],
        },
        {
            uuid: '6167f1ff2479f15da6d55714',
            description: 'Managers play a critical role in the integration of application security throughout the software development life cycle. A manager must ensure that AppSec is a goal and not an afterthought. In addition to understanding the technical aspects of application security, a manager needs to know how to instill an AppSec mindset and develop an AppSec culture in their teams. Play and learn... \r\n',
            format: 'cms',
            name: 'Best Practices for Managers',
            iconUrl: 'https://codebashing-prod-eu-content.s3-eu-west-1.amazonaws.com/courses-assets/best_practices_for_managers.svg',
            category: null,
            externalUrl: '/courses/frontend/index.html',
            challengeQuery: 'tags=lesson_application_security_for_decision_makers_best_practices_for_managers',
            duration: '5-8',
            status: 'active',
            tags: [],
            metadata: {
                active_on_free: false,
                course_name: 'appsec_for_decision_makers',
                lesson_name: 'best_practices_for_managers',
                content_name: 'application_security_for_decision_makers_best_practices_for_managers',
                content_id: 1097,
                active_on_lean: true,
            },
            publishInfo: ['~kMC*2)yN%5a}vJ9v8s726t7O#r[aA', 'OX)jOt$nPFn`b2Jy-Pa!N[DcD3@}z3'],
        },
        {
            uuid: '633936eed05748ff624e3121',
            description: 'test the score of a system lesson with Storyline',
            format: 'sl',
            name: 'A test lesson (miriam)',
            iconUrl: 'https://content.codebashing.com/courses-assets/ed48530f-76d3-4e17-876e-e1ec3d881046.svg',
            category: null,
            externalUrl: '/courses/scorm-lessons/index.html',
            challengeQuery: null,
            duration: '5-8',
            status: 'active',
            tags: [],
            metadata: {
                lesson_name: 'a_test_lesson_miriam',
                course_name: 'application_security_for_decision_makers',
                active_on_free: true,
            },
            publishInfo: ['~kMC*2)yN%5a}vJ9v8s726t7O#r[aA'],
        },
        {
            uuid: '6167f1ff2479f1ec26d55717',
            description: 'Cross-Site Request Forgery is a web security vulnerability that allows an attacker to maliciously prompt the user to inadvertently perform unwanted actions on the application and gain control of their account. Play and learn… ',
            format: 'cms',
            name: 'Cross-Site Request Forgery',
            iconUrl: 'https://content.codebashing.com/courses-assets/cross_site_request_forgery.png',
            category: null,
            externalUrl: '/courses/frontend/index.html',
            challengeQuery: 'tags=lesson_application_security_for_decision_makers_cross_site_request_forgery',
            duration: '5-8',
            status: 'active',
            tags: [
                {
                    uuid: '63a991bc1d8f6fd5ee12ae21',
                    name: 'cross_site_request_forgery',
                    displayName: 'Cross Site Request Forgery',
                    category: 'vulnerability',
                    metadata: {
                        cweId: 'CWE-352',
                        owaspId: 'A1: Broken Access Control ',
                        sansId: null,
                    },
                    tagCount: 1,
                    relatedTags: [],
                },
            ],
            metadata: {
                active_on_free: false,
                course_name: 'application_security_for_decision_makers',
                lesson_name: 'cross_site_request_forgery',
                content_name: 'application_security_for_decision_makers_cross_site_request_forgery',
                content_id: 1084,
                active_on_lean: true,
            },
            publishInfo: ['~kMC*2)yN%5a}vJ9v8s726t7O#r[aA', 'OX)jOt$nPFn`b2Jy-Pa!N[DcD3@}z3'],
        },
        {
            uuid: '63591263a878c138f7571927',
            description: 'Insecure design is a category of vulnerabilities caused by not anticipating and evaluating threats.\nDesign flaws tend to be overlooked and not easily fixed.\nAdding security measures or changing the architecture of a running app is time-consuming and costly. Play and learn…',
            format: 'sl',
            name: 'Insecure Design',
            iconUrl: 'https://content.codebashing.com/courses-assets/insecure_design.svg',
            category: null,
            externalUrl: '/courses/scorm-lessons/index.html',
            challengeQuery: null,
            duration: '5-8',
            status: 'active',
            tags: [],
            metadata: {
                course_name: 'application_security_for_qa',
                lesson_name: 'insecure_design',
            },
            publishInfo: ['~kMC*2)yN%5a}vJ9v8s726t7O#r[aA'],
        },
        {
            uuid: '635911aea878c1c06457190b',
            description: 'Cryptographic failures are a vulnerability category focusing on a lack of or inappropriate protection, which often leads to the exposure of sensitive data. Play and learn...',
            format: 'sl',
            name: 'Cryptographic Failures',
            iconUrl: 'https://content.codebashing.com/courses-assets/cryptographic_failures.svg',
            category: null,
            externalUrl: '/courses/scorm-lessons/index.html',
            challengeQuery: null,
            duration: '5-8',
            status: 'active',
            tags: [],
            metadata: {
                course_name: 'application_security_for_qa',
                lesson_name: 'cryptographic_failures',
            },
        },
        {
            uuid: '6167f206c27d3d486c952947',
            description: 'Sensitive data, such as personally identifiable information, business secrets, and sensitive system information, must be protected from unauthorized access. Failure to do so can lead to data breaches, data thefts, business disruption, and even legal penalties. It is best to employ appropriate security controls for protecting the data being used by the application. Play and learn...',
            format: 'cms',
            name: 'Sensitive Data Exposure',
            iconUrl: 'https://codebashing-prod-eu-content.s3-eu-west-1.amazonaws.com/courses-assets/sensitive_data_exposure_v2.svg',
            category: null,
            externalUrl: '/courses/frontend/index.html',
            challengeQuery: 'tags=lesson_application_security_for_qa_sensitive_data_exposure',
            duration: '5-8',
            status: 'active',
            tags: [
                {
                    uuid: '63a991c91d8f6f18dd12ae25',
                    name: 'sensitive_data_exposure',
                    displayName: 'Sensitive Data Exposure',
                    category: 'vulnerability',
                    metadata: {
                        cweId: 'CWE-540',
                        owaspId: 'A2: Cryptographic Failures',
                        sansId: null,
                    },
                    tagCount: 1,
                    relatedTags: [],
                },
            ],
            metadata: {
                active_on_free: false,
                course_name: 'application_security_for_qa',
                lesson_name: 'sensitive_data_exposure',
                content_name: 'application_security_for_qa_sensitive_data_exposure',
                content_id: 1095,
            },
            publishInfo: ['~kMC*2)yN%5a}vJ9v8s726t7O#r[aA', 'OX)jOt$nPFn`b2Jy-Pa!N[DcD3@}z3'],
        },
        {
            uuid: '6167f2062479f1daa8d55729',
            description: 'Components with known vulnerabilities can pose a serious threat to application security. Since the knowledge about these vulnerabilities is discoverable on open sources, attackers can easily exploit them to their advantage. Play and learn...',
            format: 'cms',
            name: 'Vulnerable and Outdated Components',
            iconUrl: 'https://codebashing-prod-eu-content.s3-eu-west-1.amazonaws.com/courses-assets/using_components_with_known_vulnerabilities.svg',
            category: null,
            externalUrl: '/courses/frontend/index.html',
            challengeQuery: 'tags=lesson_application_security_for_qa_using_components_with_known_vulnerabilities',
            duration: '5-8',
            status: 'active',
            tags: [
                {
                    uuid: '63a991ccec399663ece8c3c3',
                    name: 'using_components_with_known_vulnerabilities',
                    displayName: 'Using Components With Known Vulnerabilities',
                    category: 'vulnerability',
                    metadata: {
                        cweId: 'CWE-1035',
                        owaspId: 'A6: Vulnerable and Outdated Components ',
                        sansId: null,
                    },
                    tagCount: 1,
                    relatedTags: [],
                },
            ],
            metadata: {
                active_on_free: false,
                course_name: 'application_security_for_qa',
                lesson_name: 'using_components_with_known_vulnerabilities',
                content_name: 'application_security_for_qa_using_components_with_known_vulnerabilities',
                content_id: 1096,
            },
            publishInfo: ['~kMC*2)yN%5a}vJ9v8s726t7O#r[aA', 'OX)jOt$nPFn`b2Jy-Pa!N[DcD3@}z3'],
        },
    ],
};
exports.mockNewLessonsResponse = {
    lessons: [
        {
            uuid: '3',
            category: 'Authentication',
            challengeQuery: 'tags=Forceful-Browsing',
            description: 'Forceful (or forced) browsing is a common attack technique used to gain access to web server resources that are restricted, or resources that are accessed outside of the intended (correct) sequence. An attacker carries out the attack by guessing, knowing or inferring the correct URL directly. If the restricted URLs, scripts, or files that reside in the web server directory are not enforced with appropriate authorization or sequencing logic, they can be vulnerable to forceful browsing attacks.',
            duration: '5-8',
            externalUrl: '/courses/android/index.html',
            format: 'cms',
            iconUrl: 'https://codebashing-prod-eu-content.s3.eu-west-1.amazonaws.com/courses/android/icons/forceful_browsing.png',
            metadata: {
                active_on_free: true,
                content_id: 855,
                content_name: 'forceful_browsing_android',
                course_name: 'android',
                lesson_name: 'forceful_browsing',
                new_lesson_free: true,
            },
            name: 'Lesson #3',
            status: 'active',
        },
        {
            uuid: '4',
            category: 'Authentication',
            challengeQuery: 'tags=Forceful-Browsing',
            description: 'Forceful (or forced) browsing is a common attack technique used to gain access to web server resources that are restricted, or resources that are accessed outside of the intended (correct) sequence. An attacker carries out the attack by guessing, knowing or inferring the correct URL directly. If the restricted URLs, scripts, or files that reside in the web server directory are not enforced with appropriate authorization or sequencing logic, they can be vulnerable to forceful browsing attacks.',
            duration: '5-8',
            externalUrl: '/courses/android/index.html',
            format: 'cms',
            iconUrl: 'https://codebashing-prod-eu-content.s3.eu-west-1.amazonaws.com/courses/android/icons/forceful_browsing.png',
            metadata: {
                active_on_free: true,
                content_id: 855,
                content_name: 'forceful_browsing_android',
                course_name: 'android',
                lesson_name: 'forceful_browsing',
                new_lesson_free: true,
            },
            name: 'Lesson #4',
            status: 'active',
        },
    ],
};
